window.addEventListener("scroll", function () {
  let stickyForm = document.querySelector(".sticky-add-to-cart");
  let elementTarget = document.querySelector(".product__info-container");
  let headerElementHeight =
    document.querySelector("sticky-header")?.offsetHeight;

  let elementTargetView = elementTarget.getBoundingClientRect();
  let isOutViewport = document
    .querySelector(".section-header")
    ?.classList.contains("shopify-section-header-hidden")
    ? elementTargetView.bottom
    : elementTargetView.bottom - headerElementHeight;

  let maxScrollTop =
    document.documentElement.scrollHeight - window.innerHeight - 80;
  if (isOutViewport < 0 && document.documentElement.scrollTop < maxScrollTop) {
    stickyForm?.classList.remove("sticky-add-to-cart-hidden");
    document.body.classList.add("sticky-add-to-cart-visible");
  } else {
    stickyForm?.classList.add("sticky-add-to-cart-hidden");
    document.body.classList.remove("sticky-add-to-cart-visible");
  }
});
